import React from 'react';
import {
  InstallationStatus,
  JobFormDataInput,
} from '@ecosconnect/core/src/types/jobFormData';
import { useHistory } from 'react-router-dom';
import useMode from '../../../hooks/useMode';
import Accordion from '../../Accordion/Accordion';
import StatusChip from '../../Status/StatusChip';
import AccordionItem from '../../Accordion/AccordionItem';
import { format, parseISO } from 'date-fns';
import { AssemblyInfo } from '@/components/Job/queries';
import { assemblyModelLabel } from './assemblyModelLabel';

const BackflowTestAssembly: React.FC<{
  originalBackflowAssembly?: AssemblyInfo;
  backflowAssemblyId?: string | number;
  formAssembly?: AssemblyInfo;
  formData: JobFormDataInput;
}> = ({
  originalBackflowAssembly,
  backflowAssemblyId,
  formAssembly,
  formData,
}) => {
  const history = useHistory();
  const mode = useMode();

  let installationStatusBadge: JSX.Element | undefined;
  if (formData.installationStatus === InstallationStatus.NEW) {
    installationStatusBadge = <StatusChip status="success">New</StatusChip>;
  } else if (formData.installationStatus === InstallationStatus.EXISTING) {
    installationStatusBadge = (
      <StatusChip status="default">Existing</StatusChip>
    );
  } else if (formData.installationStatus === InstallationStatus.REPLACEMENT) {
    installationStatusBadge = (
      <StatusChip status="success">Replaced</StatusChip>
    );
  } else if (formData.installationStatus === InstallationStatus.REMOVED) {
    installationStatusBadge = <StatusChip status="error">Removed</StatusChip>;
  }

  if (formData.installationStatus === InstallationStatus.REMOVED) {
    return <Accordion title="Assembly" icon={installationStatusBadge} />;
  }

  if (!formAssembly) {
    return <Accordion title="Assembly" />;
  }

  if (formData) {
    let flag: string | null = null;
    if (formData.improperlyInstalled) {
      flag = 'Improperly Installed';
    } else if (formData.unableToTest) {
      flag = 'Not Testable';
    } else if (formData.repairsRequired) {
      flag = 'Repairs Required';
    }
    if (flag) {
      installationStatusBadge = <StatusChip status="error">{flag}</StatusChip>;
    }
  }

  return (
    <Accordion title="Assembly" icon={installationStatusBadge}>
      <AccordionItem
        kind="link"
        label="Serial"
        oldValue={originalBackflowAssembly?.serialNumber}
        value={formAssembly.serialNumber}
        href={
          backflowAssemblyId
            ? `/${mode}/assemblies/${backflowAssemblyId}`
            : undefined
        }
      />
      <AccordionItem
        label="Model"
        oldValue={assemblyModelLabel(originalBackflowAssembly)}
        value={assemblyModelLabel(formAssembly)}
      />
      <AccordionItem
        label="Type"
        oldValue={originalBackflowAssembly?.type?.replace(/_/g, ' ')}
        value={formAssembly.type?.replace(/_/g, ' ')}
      />
      <AccordionItem
        label="Size"
        oldValue={
          originalBackflowAssembly
            ? originalBackflowAssembly?.size + '"'
            : undefined
        }
        value={formAssembly.size ? formAssembly.size + '"' : undefined}
      />
      <AccordionItem
        label="Location"
        oldValue={originalBackflowAssembly?.location}
        value={formAssembly.location}
      />
      <AccordionItem
        label="Install Date"
        value={
          originalBackflowAssembly?.installDate &&
          !originalBackflowAssembly.installDate.startsWith('00')
            ? format(parseISO(originalBackflowAssembly.installDate), 'M/d/yyyy')
            : '-'
        }
      />
    </Accordion>
  );
};

export default BackflowTestAssembly;
